import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
LogRocket.init('ttrvgx/good-humans-image-bank');
setupLogRocketReact(LogRocket);
export default LogRocket;